export default __webpack_public_path__ + "static/realWorldImg5-b1f5fe73a6c1a9efcf01e9b744840317.png";